// Social Security Number formatting
export function formatSSN(value) {
	const matches = String(value).match(/^(\d{3})-?(\d{2})-?(\d{4})$/);
	if (matches?.length >= 3) {
		const areaNumber = matches[1];
		const groupNumber = matches[2];
		const serialNumber = matches[3];
		return `${areaNumber}-${groupNumber}-${serialNumber}`;
	}

	return value;
}
